import { createTheme } from '@mui/material/styles';
import { scaleColor } from './utils/colors';

const primaryFont = '"Montserrat", "Roboto", "Arial", sans-serif';
const accentFont = '"Playfair Display", "Times New Roman", serif';

export const brandColors = {
  green: '#003a27',
  gold: '#d28b21',
  red: '#c61718',
  black: '#0e1513',
  ivory: '#f0e6c4'
};

export const priceColors = {
  low: brandColors.ivory,
  medium: brandColors.gold,
  high: brandColors.gold,
  veryHigh: brandColors.red
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: brandColors.green,
      contrastText: brandColors.ivory
    },
    secondary: {
      main: brandColors.gold,
      contrastText: brandColors.black
    },
    error: {
      main: brandColors.red
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff'
    },
    text: {
      primary: brandColors.black,
      secondary: '#2c3a2f'
    },
    brand: brandColors,
    priceTiers: priceColors
  },
  typography: {
    fontFamily: primaryFont,
    h1: {
      fontFamily: accentFont,
      fontSize: '3rem',
      fontWeight: 600,
      letterSpacing: '-0.02em'
    },
    h2: {
      fontFamily: accentFont,
      fontSize: '2.2rem',
      fontWeight: 500
    },
    h3: {
      fontFamily: accentFont,
      fontSize: '1.8rem'
    },
    h4: {
      fontWeight: 600,
      letterSpacing: '0.08em',
      textTransform: 'uppercase'
    },
    h5: {
      fontWeight: 500
    },
    subtitle1: {
      fontSize: '1.1rem',
      color: '#4c5565'
    },
    body1: {
      fontSize: '1.05rem',
      lineHeight: 1.8,
      color: '#353a47'
    },
    body2: {
      fontSize: '0.95rem',
      color: '#4c5565'
    },
    button: {
      textTransform: 'none',
      fontWeight: 600
    }
  },
  shape: {
    borderRadius: 12
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#ffffff',
          color: brandColors.black
        },
        a: {
          color: 'inherit'
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 6px 20px rgba(15, 61, 62, 0.12)'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          padding: '0.8rem 1.8rem'
        },
        containedSecondary: {
          color: brandColors.black
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          boxShadow: '0 20px 60px rgba(14, 21, 19, 0.12)'
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          margin: '16px 0'
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          borderRadius: 12,
          transition: 'background-color 0.2s ease',
          '&:hover': {
            backgroundColor: '#ffffff'
          },
          '&.Mui-focused': {
            backgroundColor: '#ffffff'
          }
        },
        input: {
          backgroundColor: 'transparent'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          borderRadius: 12,
          transition: 'background-color 0.2s ease',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0,0,0,0.2)'
          },
          '&:hover': {
            backgroundColor: '#ffffff',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0,0,0,0.4)'
            }
          },
          '&.Mui-focused': {
            backgroundColor: '#ffffff',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: brandColors.green
            }
          }
        },
        input: {
          backgroundColor: 'transparent'
        }
      }
    }
  }
});

export default theme;
